import React                      from 'react'
import { observer }               from 'mobx-react'
import store                      from 'stores/ResetPasswordStore'
import { SubmitButton, FormIcon } from '../Common'
import { Form, Input }            from 'antd'
import ResetPasswordAlert         from './ResetPasswordAlert'

const FormItem = Form.Item

@observer
class UsernameVerificationForm extends React.Component {
  componentWillUnmount() {
    store.resetError()
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        store.verifyUsername(values.username)
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    return (
      <Form onSubmit={this.handleSubmit}>
        {store.showError && (
          <ResetPasswordAlert
            message={store.errorTitle}
            description={store.errorMessage}
            type="error"
            className="mb-4"
            closable
          />
        )}
        <p style={{fontSize: '16px', fontWeight: '400'}} className="mb-4">
          Please enter your email address first:
        </p>
        <FormItem>
          {getFieldDecorator('username', {
            validateTrigger: ['onSubmit'],
            rules:           [
              {
                type:    'email',
                message: 'Please enter a valid email address'
              },
              {
                required: true,
                message:  'Please enter your email address'
              }
            ]
          })(
            <Input
              placeholder="name@example.com"
              name="email"
              size="large"
              style={{width: '400px'}}
            />
          )}
        </FormItem>
        <FormItem>
          <SubmitButton
            loading={store.isVerifyingUsername}
            size="lg"
            className="w-100"
            style={{backgroundColor: 'black', color: 'white', borderRadius: '8px'}}
          >
            Reset Password
          </SubmitButton>
        </FormItem>
      </Form>
    )
  }
}

const WrappedUsernameVerificationForm = Form.create()(
  UsernameVerificationForm
)

export default WrappedUsernameVerificationForm
